import { nextStep } from 'New/redux/actions/actions';
import React from 'react';
import { connect } from 'react-redux';

const WarningModal = (props) => {
    const {
        showWarningModal,
        setShowWarningModal,
        previewUrl,
    } = props;
    const buttonStyle = {
        fontWeight: "600",
        color: "#6a6a6a",
        width: "80%",
        margin: "0 auto",
        border: "none",
        boxShadow: "2px 2px #ccc",
    }
    return (
        <div className="WarningModal" style={{ display: showWarningModal ? 'flex' : 'none' }}>
            <p style={{
                margin: "10px",
                border: "1px #000 solid",
                background: "#ff0",
            }}>
                No still image in library
            </p>
            <h4 style={{
                lineHeight: "normal",
                width: "90%",
                margin: "0 auto",
                color: "#000",
                fontWeight: "bold",
                fontSize: "1.5rem",
            }}>
                1 still image is required for <br /> the loading screen
            </h4>
            <button 
                style={buttonStyle}
                onClick={() =>{
                    props.nextStep("upload images", "image library");
                }}>
                Add image to Image Library
            </button>
            <a style={{
                color: "blue"
            }}
                href={previewUrl}
                onClick={(e) => {
                    if (!previewUrl) {
                        e.preventDefault();
                        setShowWarningModal(false);
                    }
                }}
                target='blank'>
                I'll do it later &gt;
            </a>
            <button 
                style={buttonStyle}
                onClick={(e) => {
                    setShowWarningModal(false);
                }}>
                Cancel and continue editing
            </button>
        </div>
    )
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
    }
}

export default connect(null, putActions)(WarningModal);
